export default "__VITE_ASSET__ChFKqLUk__"